export default __webpack_public_path__ + "static/media/640_blank-nl-mobile.99c95514.png";